import {createElement} from 'react';
import './view-type-toggler.scss';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {IconButton, Tooltip} from '@mui/material';
import {SvgIconComponent} from '@mui/icons-material';

export type ViewTogglerProps<T> = {
  value: T;
  options: ViewTogglerOption<T>[];
  onClick: (type: T) => void;
};

export type ViewTogglerOption<T> = {
  id: T;
  icon: SvgIconComponent;
  name: string;
};

export function ViewTypeToggler<T>({value, options, onClick}: ViewTogglerProps<T>) {
  const {t} = useTranslation();

  return (
    <div className="index-screen-view-toggler">
      {options.map((option) => (
        <Tooltip
          key={`toggler-option-${option.id}`}
          title={t(translations.view_type_toggler.tooltip_message, {type: option.name})}
        >
          <IconButton
            className="index-screen-view-toggler-item"
            onClick={() => onClick(option.id)}
            sx={{
              backgroundColor: value === option.id ? 'primary.contrastText' : 'transparent',
              color: value === option.id ? 'blue.main' : 'primary.contrastText',
              '&:hover': {
                backgroundColor: 'primary.contrastText',
                color: 'blue.main',
              },
              '&:active': {
                backgroundColor: 'primary.contrastText',
                color: 'blue.main',
              },
            }}
          >
            {createElement(option.icon, {sx: {color: 'currentColor'}})}
          </IconButton>
        </Tooltip>
      ))}
    </div>
  );
}
